import { Coordinate } from 'components/form/inputs/coordinatesInput/helpers/coordinateTranslations'
import { GeckoMarkupLayer, RolodexEntryTagsType, RolodexEntryType } from 'types'

const COORDINATE_HIGHLIGHT_COLOR = '#1890ff'
const COORDINATE_HIGHLIGHT_RADIUS = 4

/**
 * Libra-local port of the coordinate-display logic in
 * `pages/details/extensions/flow/assetModelEditorExt/useGetCoordinateDisplayFns.ts`.
 *
 * Builds transient `GeckoMarkupLayer[]` entries so the asset model editor's
 * point-pick / highlight flows can render coordinates on top of the embedded
 * `ForecastAssetVizWindow`. The asset model step binds the active component's
 * tags into each call so the markup is scoped correctly.
 *
 * Note: this intentionally bypasses `GeckoMarkupLayer.CreateFromJSON` because
 * there is no canonical "point" primitive in the markup layer schema (only
 * icon / label / line / polygon / rect). The viewer's renderer has a special
 * path that reads `data.pointPrimitives` directly off the transient layer.
 * The cast below is the documented escape hatch for that path.
 */
export function buildCoordinateMarkupLayers(
  coords: ReadonlyArray<Coordinate>,
  componentTags: RolodexEntryTagsType
): GeckoMarkupLayer[] {
  if (coords.length === 0) return []
  const data = {
    rectPrimitives: [],
    pointPrimitives: coords.map((coord, idx) => ({
      id: `ffs-coord-${idx}`,
      x: coord.x,
      y: coord.y,
      color: COORDINATE_HIGHLIGHT_COLOR,
      radius: COORDINATE_HIGHLIGHT_RADIUS,
    })),
  }
  return [
    {
      id: 'ffs-coordinate-highlights',
      type: RolodexEntryType.MARKUP_LAYER,
      tags: componentTags,
      data,
    } as unknown as GeckoMarkupLayer,
  ]
}
